import { Group, Text } from "@mantine/core";
import { type ComponentPropsWithoutRef, forwardRef } from "react";

interface ItemProps extends ComponentPropsWithoutRef<"div"> {
  label: string;
  dropdownLabel?: string;
  chrisKey?: string;
  contactNumber?: string;
  isLabel?: boolean;
}

const CustomSelectItem = forwardRef<HTMLDivElement, ItemProps>(
  (
    {
      label,
      dropdownLabel,
      chrisKey,
      contactNumber,
      isLabel,
      ...others
    }: ItemProps,
    ref,
  ) => (
    <div
      ref={ref}
      {...others}
      style={
        isLabel ? { pointerEvents: "none", cursor: "default" } : undefined
      }>
      <Group noWrap>
        <div style={{ flex: 1 }}>
          <Text size="sm" color="text" fw={isLabel ? 200 : undefined}>
            {dropdownLabel ?? label}
          </Text>
          {contactNumber && (
            <Text size="xs" color="text">
              {`Contact: ${contactNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")}`}
            </Text>
          )}
        </div>
      </Group>
    </div>
  ),
);

export default CustomSelectItem;
